import React, { useContext } from 'react';
import WebinarsContext from 'webinars/context';

import './styles';

const WebinarHost = () => {
  const {
    webinar: { hostProfile },
  } = useContext(WebinarsContext);
  const hostProfileFound = Boolean(Object.keys(hostProfile).length);

  return (
    hostProfileFound && (
      <div className="webinar-host-wrapper">
        <div>
          <span>Hosted by:</span>
          <h3>{hostProfile.name}</h3>
        </div>
        <img src={hostProfile.imageUrl} alt={`Photo of ${hostProfile.name}`} />
        <span className="host-title">{hostProfile.title}</span>
      </div>
    )
  );
};

export default WebinarHost;
